import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageLisboa = props => {
  return <CityLandingPage cityKey="Lisboa" cityConfig={cityContent.lisboa} {...props} />;
};

export default LandingPageLisboa;
